/* ============================================================================
   BEYOURS BUY BOX — JS extracted from snippets/product-form-alternate.liquid
   ----------------------------------------------------------------------------
   What this fixes vs the previous 7 inline <script> blocks:

   Instant-navigation bug
   ----------------------
   The cross-product colour swatch (<color-metafield>) navigates between
   products by setting .main-product-alternate.innerHTML = newHtml. Per HTML
   spec, inline <script> tags inside assigned innerHTML are parsed but NEVER
   executed. So all 7 inline scripts died on swatch nav — the new form had no
   click validators, the sticky text stayed stuck on "Pick a size", etc.

   Fix:
   - This file is an EXTERNAL script. It loads once and stays loaded.
   - Document-level handlers (change, click for copy/scroll, scroll for sticky)
     are registered ONCE — they live on document/window so they survive any
     subtree swap. They internally query the DOM fresh, so they always see the
     current .beyours-bb.
   - Element-level handlers (the nudge's click guards on the ATC button +
     submit guards on the form) MUST bind to specific elements. init() rebinds
     them every time, guarded by an idempotency flag on the element itself
     (not in closure state) so that pre-existing bindings on still-live
     elements aren't double-bound.
   - <color-metafield>'s post-swap code (theme.js) now dispatches
     'bb:section-reloaded' on document. We listen for it and re-run init().
   - State (form id, colour/size option indexes) is read from data-attrs on
     .beyours-bb every call — never captured in closure at script-load time.
   ============================================================================ */

(function() {
  'use strict';

  // ==========================================================================
  // STATE — always read fresh from the DOM, never captured in closure
  // ==========================================================================

  function getState() {
    var bb = document.querySelector('.beyours-bb');
    if (!bb) return null;
    var formId = bb.getAttribute('data-form-id');
    return {
      bb: bb,
      formId: formId,
      form: formId ? document.getElementById(formId) : null,
      colorIdx: parseInt(bb.getAttribute('data-bb-color-idx') || '-1', 10),
      sizeIdx: parseInt(bb.getAttribute('data-bb-size-idx') || '-1', 10)
    };
  }

  function fmtINR(n) {
    return '₹' + Math.round(n).toLocaleString('en-IN');
  }

  function getVariants(bb) {
    var el = bb.querySelector('[data-bb-variants-json]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function getCurrentVariantId(state) {
    if (!state || !state.form) return null;
    var idInput = state.form.querySelector('input[name="id"]');
    if (!idInput || idInput.disabled || !idInput.value) return null;
    return idInput.value;
  }

  // ==========================================================================
  // BLOCK 1: STICKY/PRICE/TITLE REPAINT
  // ==========================================================================

  function resetStickyTextToPrompt(bb) {
    var stickyText = bb.querySelector('[data-bb-sticky-text]');
    var stickyPrompt = bb.querySelector('[data-bb-sticky-prompt]');
    if (stickyText) { stickyText.textContent = ''; stickyText.style.display = 'none'; }
    if (stickyPrompt) stickyPrompt.style.display = '';
  }

  function repaint() {
    var state = getState();
    if (!state) return;
    var vid = getCurrentVariantId(state);
    if (!vid) { resetStickyTextToPrompt(state.bb); return; }

    var variants = getVariants(state.bb);
    var variant = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(vid)) { variant = variants[i]; break; }
    }
    if (!variant) { resetStickyTextToPrompt(state.bb); return; }

    var stickyText = state.bb.querySelector('[data-bb-sticky-text]');
    var stickyPrompt = state.bb.querySelector('[data-bb-sticky-prompt]');
    if (stickyText) {
      var parts = [];
      if (state.sizeIdx >= 0 && variant.options[state.sizeIdx]) parts.push(variant.options[state.sizeIdx]);
      if (state.colorIdx >= 0 && variant.options[state.colorIdx]) parts.push(variant.options[state.colorIdx]);
      stickyText.textContent = parts.join(' · ');
      stickyText.style.display = '';
    }
    if (stickyPrompt) stickyPrompt.style.display = 'none';

    var stickyPrice = state.bb.querySelector('[data-bb-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = fmtINR(variant.price / 100);
    var stickyMrp = state.bb.querySelector('[data-bb-sticky-mrp]');
    if (stickyMrp) {
      if (variant.compare_at_price > variant.price) {
        stickyMrp.textContent = fmtINR(variant.compare_at_price / 100);
        stickyMrp.style.display = '';
      } else {
        stickyMrp.style.display = 'none';
      }
    }

    var thumb = state.bb.querySelector('[data-bb-thumb]');
    if (thumb && variant.featured_image) {
      thumb.innerHTML = '<img src="' + variant.featured_image.src + '&width=108" width="36" height="54" alt="" loading="lazy">';
    }

    var mainPrice = state.bb.querySelector('[data-bb-price]');
    if (mainPrice) mainPrice.textContent = fmtINR(variant.price / 100);
    var mainMrp = state.bb.querySelector('[data-bb-mrp]');
    if (mainMrp && variant.compare_at_price > variant.price) {
      mainMrp.textContent = fmtINR(variant.compare_at_price / 100);
    }
    var mainSave = state.bb.querySelector('[data-bb-save]');
    if (mainSave) {
      if (variant.compare_at_price > variant.price) {
        var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        mainSave.textContent = 'SAVE ' + pct + '%';
        mainSave.style.display = '';
      } else {
        mainSave.style.display = 'none';
      }
    }

    var emiStrip = state.bb.querySelector('[data-bb-emi-strip]');
    var emiAmount = state.bb.querySelector('[data-bb-emi-amount]');
    if (emiStrip && emiAmount) {
      if (variant.price >= 99900) {
        emiAmount.textContent = fmtINR(variant.price / 100 / 3);
        emiStrip.style.display = '';
      } else {
        emiStrip.style.display = 'none';
      }
    }

    // The rust discounted sticky price for variants over Rs.2,000 was removed 2026-09-07
    // with the flat 10% offer, so there is nothing to toggle: the normal row always shows.
    var stickyNormal = state.bb.querySelector('[data-bb-sticky-normal]');
    if (stickyNormal) stickyNormal.style.display = '';

    if (state.colorIdx >= 0) {
      var titleColorEl = state.bb.querySelector('[data-bb-title-color]');
      if (titleColorEl) titleColorEl.textContent = ' · ' + variant.options[state.colorIdx];
      var colorValEl = state.bb.querySelector('[id^="bb-color-value-"]');
      if (colorValEl) colorValEl.textContent = variant.options[state.colorIdx];
    }
  }

  function updateLengthMeta() {
    var state = getState();
    if (!state) return;
    var el = state.bb.querySelector('[data-bb-length-name]');
    if (!el) return;
    var checked = state.bb.querySelector('.bb-length-pill input[type="radio"]:checked');
    if (!checked) { el.textContent = ''; return; }
    var pill = checked.closest('.bb-length-pill');
    el.textContent = pill ? (pill.getAttribute('data-size-details') || '') : '';
  }

  // Document-level — registered once at script load, survives any DOM swap.
  function onRadioChange(e) {
    if (!e.target || !e.target.matches || !e.target.matches('input[type="radio"]')) return;
    // Defer so <product-variants> resolves and writes the id input first
    setTimeout(function() { repaint(); updateLengthMeta(); }, 30);
  }

  // ==========================================================================
  // BLOCK 2: STICKY SHOW/HIDE ON SCROLL
  // ==========================================================================

  function updateStickyVisibility() {
    var sticky = document.querySelector('.beyours-bb .bb-sticky');
    if (!sticky) return;
    // Bundle/pack products: .bb-sticky is an inline container holding the ATB +
    // Rapi block (not a floating bar). Never scroll-hide it, and strip any stale
    // hidden class so it stays visible at all scroll positions / widths.
    if (sticky.closest('.beyours-bb[data-bb-pack]')) {
      sticky.classList.remove('bb-sticky-hidden');
      return;
    }
    // The Add to Bag block is now in the flow, directly under the size picker, on every
    // product -- not a bar that flies up from the bottom past half a viewport of scroll.
    // So there is nothing left to show or hide on scroll, and the mobile/desktop split is
    // the stylesheet's job (the 1000px media query hides .bb-sticky and reveals
    // .bb-desktop-atc-block). Stale hidden classes are stripped so a cached copy of the
    // old script cannot leave the button invisible.
    sticky.classList.remove('bb-sticky-hidden');
  }

  // ==========================================================================
  // BLOCK 4: REVIEWS BADGE COMPACT DISPLAY
  // ==========================================================================

  function buildReviewsDisplay() {
    var meta = document.querySelector('.bb-acc-meta--reviews');
    if (!meta) return false;
    if (meta.querySelector('.bb-rev-display')) return true;

    var badge = meta.querySelector('.jdgm-prev-badge[data-average-rating]');
    if (!badge) return false;

    var rating = badge.getAttribute('data-average-rating');
    var count = badge.getAttribute('data-number-of-reviews');
    if (rating == null || count == null) return false;

    var num = parseFloat(rating);
    var cnt = parseInt(count, 10);
    if (isNaN(num) || isNaN(cnt)) return false;
    if (cnt === 0) {
      var emptyRow = document.querySelector('.bb-acc-row--reviews');
      if (emptyRow) emptyRow.style.display = 'none';
      return true;
    }

    var ratingText = num.toFixed(2).replace(/\.?0+$/, '');
    var span = document.createElement('span');
    span.className = 'bb-rev-display';
    span.innerHTML =
      '<span class="bb-rev-star">★</span>' +
      '<span class="bb-rev-rating">' + ratingText + '</span>' +
      '<span class="bb-rev-count">(' + cnt + ')</span>';
    meta.appendChild(span);
    return true;
  }

  var _reviewsAttempts = 0;
  var _reviewsInterval = null;
  function initReviewsBadge() {
    _reviewsAttempts = 0;
    if (_reviewsInterval) clearInterval(_reviewsInterval);
    if (buildReviewsDisplay()) return;
    _reviewsInterval = setInterval(function() {
      if (buildReviewsDisplay() || ++_reviewsAttempts >= 20) {
        clearInterval(_reviewsInterval);
        _reviewsInterval = null;
        if (_reviewsAttempts >= 20) {
          var meta = document.querySelector('.bb-acc-meta--reviews');
          var row = document.querySelector('.bb-acc-row--reviews');
          if (row && meta && !meta.querySelector('.bb-rev-display')) {
            row.style.display = 'none';
          }
        }
      }
    }, 250);
  }

  // ==========================================================================
  // BLOCK 5: SCROLL TO REVIEWS
  // ==========================================================================

  function onScrollToReviewsClick(e) {
    var btn = e.target.closest && e.target.closest('[data-bb-scroll-to-reviews]');
    if (!btn) return;
    e.preventDefault();
    var target = document.getElementById('judgeme_product_reviews') ||
                 document.querySelector('.jdgm-rev-widg') ||
                 document.querySelector('.jdgm-widget') ||
                 document.querySelector('#shopify-product-reviews');
    if (!target) return;
    var headerOffset = 80;
    var top = target.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - headerOffset;
    if (top < 0) top = 0;
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({ top: top, behavior: 'smooth' });
    } else {
      window.scrollTo(0, top);
    }
  }

  // ==========================================================================
  // BLOCK 6: EDD PINCODE CHECKER
  // ==========================================================================

  var EDD_API = 'https://script.google.com/macros/s/AKfycbzd3jvoxMjAUaHU7UHCLCYdsMVxjCf1pAEv5jwJ7foL9r89iBWoTRebRx5Ssj4IyYXL/exec';

  function getPincodeData() {
    try { return JSON.parse(localStorage.getItem('pincodeData') || '[]'); }
    catch (e) { return []; }
  }
  function shouldRefreshPincodeData() {
    var ts = +(localStorage.getItem('dataTimestamp') || 0);
    return !ts || Date.now() - ts > 86400000;
  }
  function fetchPincodeData() {
    return fetch(EDD_API).then(function(r) { return r.json(); }).then(function(data) {
      if (data && data.data && data.data.length) {
        localStorage.setItem('pincodeData', JSON.stringify(data.data));
        localStorage.setItem('dataTimestamp', String(Date.now()));
      }
    }).catch(function() {});
  }
  function binarySearchPincode(pincode) {
    var data = getPincodeData();
    var l = 0, r = data.length - 1;
    while (l <= r) {
      var m = Math.floor((l + r) / 2);
      var p = +data[m].pincode;
      if (p === pincode) return +data[m].date;
      if (p < pincode) l = m + 1; else r = m - 1;
    }
    return null;
  }
  function fmtDate(d) {
    return d.getDate() + ' ' + d.toLocaleString('default', { month: 'short' });
  }

  function bindEddInstance(eddContainer) {
    var input = eddContainer.querySelector('[data-bb-edd-input]');
    var btn = eddContainer.querySelector('[data-bb-edd-btn]');
    var resultEl = eddContainer.querySelector('[data-bb-edd-result]');
    var msgEl = eddContainer.querySelector('[data-bb-edd-message]');
    if (!input || !btn) return;
    if (eddContainer._bbEddBound) return;
    eddContainer._bbEddBound = true;

    function showResult(message, isError) {
      if (!resultEl || !msgEl) return;
      msgEl.textContent = message;
      resultEl.classList.remove('hidden');
      resultEl.classList.toggle('is-error', !!isError);
      var labelEl = resultEl.querySelector('.bb-edd-result-label');
      if (labelEl) labelEl.textContent = isError ? 'Try again' : 'Estimated delivery';
    }

    function checkPincode() {
      var pincode = (input.value || '').trim();
      if (!/^\d{6}$/.test(pincode)) {
        showResult('Please enter a valid 6-digit pincode', true);
        return;
      }
      localStorage.setItem('lastPincode', pincode);
      document.querySelectorAll('[data-bb-edd-input]').forEach(function(other) {
        if (other !== input) other.value = pincode;
      });
      var days = binarySearchPincode(+pincode);
      if (days == null) days = 5;
      var now = new Date();
      var d1 = new Date(now); d1.setDate(now.getDate() + days - 1);
      var d2 = new Date(now); d2.setDate(now.getDate() + days);
      var dateRange = fmtDate(d1) + ' – ' + fmtDate(d2);
      showResult(dateRange, false);
      var hint = document.querySelector('[data-bb-delivery-hint]');
      if (hint && !hint.classList.contains('bb-acc-meta--rust')) {
        hint.textContent = 'Delivery by ' + fmtDate(d1);
      }
    }

    btn.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); checkPincode(); });
    input.addEventListener('keydown', function(e) { if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); checkPincode(); } });
    input.addEventListener('input', function() { input.value = (input.value || '').replace(/\D/g, '').slice(0, 6); });

    var savedPincode = localStorage.getItem('lastPincode');
    if (savedPincode && /^\d{6}$/.test(savedPincode)) {
      input.value = savedPincode;
      if (getPincodeData().length === 0) {
        fetchPincodeData().then(checkPincode);
      } else {
        checkPincode();
      }
    }
  }

  function initEdd() {
    if (shouldRefreshPincodeData()) fetchPincodeData();
    document.querySelectorAll('.bb-edd').forEach(bindEddInstance);
  }

  // Document-level: re-run initEdd when user opens the Delivery popover (the
  // popover may inject its inner HTML lazily, so .bb-edd doesn't exist yet on
  // first page load).
  function onDeliveryOpen(e) {
    if (!e.target || !e.target.closest) return;
    var trigger = e.target.closest('[aria-controls*="-delivery-popover"], [aria-controls*="-delivery-drawer"]');
    if (!trigger) return;
    initEdd();
    setTimeout(initEdd, 60);
    setTimeout(initEdd, 200);
    setTimeout(initEdd, 500);
  }

  // ==========================================================================
  // BLOCK 7: BEYOURS NUDGE (pre-submit "Pick a size" validation)
  // This is the one that binds to specific form/button elements, so it
  // MUST rebind every time the section is reloaded.
  // ==========================================================================

  function initBeyoursNudge() {
    var state = getState();
    if (!state || !state.form) return;
    var form = state.form;
    var formId = state.formId;
    var nudge = document.getElementById('beyours-nudge-' + formId);
    if (!nudge) return;
    // Element-keyed idempotency: the new form (after innerHTML swap) has no
    // flag, so we WILL bind. The old form is gone, so its flag doesn't matter.
    if (form._bbNudgeBound) return;
    form._bbNudgeBound = true;

    var nudgeText = nudge.querySelector('.beyours-nudge__text');
    var submitBtns = form.querySelectorAll('#AddToCart, button[type="submit"], [data-bb-atc], [data-bb-atc-desktop]');

    function findOptionGroups() {
      var radios = document.querySelectorAll('input[type="radio"]');
      var groups = {};
      for (var i = 0; i < radios.length; i++) {
        var r = radios[i];
        if (r.getAttribute('form') !== formId) continue;
        if (!r.name || !/^option\d+$/.test(r.name)) continue;
        if (!groups[r.name]) groups[r.name] = { name: r.name, radios: [] };
        groups[r.name].radios.push(r);
      }
      return Object.keys(groups)
        .sort(function(a, b) { return (+a.replace('option', '')) - (+b.replace('option', '')); })
        .map(function(n) { return groups[n]; });
    }

    function getContainerForGroup(group) {
      if (!group || !group.radios[0]) return null;
      var firstRadio = group.radios[0];
      return firstRadio.closest(
        '.bb-length-block, .bb-size-block, .bb-color-block, .bb-color-swatch-block, ' +
        '.product-form__option-selector'
      ) || firstRadio.closest('label') || firstRadio.parentElement;
    }

    function getMissingSelector() {
      var groups = findOptionGroups();
      for (var i = 0; i < groups.length; i++) {
        var anyChecked = false;
        for (var j = 0; j < groups[i].radios.length; j++) {
          if (groups[i].radios[j].checked) { anyChecked = true; break; }
        }
        if (!anyChecked) {
          var container = getContainerForGroup(groups[i]);
          if (container) container._bbOptionName = groups[i].name;
          return container;
        }
      }
      return null;
    }

    function messageFor(container) {
      if (!container) return 'Select all options to continue';
      if (container.classList) {
        if (container.classList.contains('bb-length-block')) return 'Now pick your length';
        if (container.classList.contains('bb-size-block')) return 'Pick a size to continue';
        if (container.classList.contains('bb-color-block') ||
            container.classList.contains('bb-color-swatch-block')) return 'Pick a colour to continue';
      }
      var optName = container._bbOptionName;
      if (optName === 'option1') return 'Pick a size to continue';
      if (optName === 'option2') return 'Now pick your length';
      if (optName === 'option3') return 'Pick the next option';
      var nameEl = container.querySelector && container.querySelector('.product-form__option-name');
      if (nameEl) {
        var label = nameEl.textContent.replace(':', '').trim().toLowerCase();
        if (label.indexOf('length') > -1) return 'Now pick your length';
        if (label.indexOf('size') > -1) return 'Pick a size to continue';
        if (label.indexOf('color') > -1 || label.indexOf('colour') > -1) return 'Pick a colour to continue';
      }
      return 'Please select all options to continue';
    }

    function showNudge(container, withAnimation) {
      nudge.setAttribute('data-show', 'true');
      if (nudgeText) nudgeText.textContent = messageFor(container);
      if (withAnimation && container) {
        try { container.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
        var animTarget = container.querySelector('.bb-length-grid, .bb-size-grid, .bb-color-swatches, .beyours-image-swatches') || container;
        animTarget.classList.remove('beyours-shake', 'beyours-pulse-target');
        void animTarget.offsetWidth;
        animTarget.classList.add('beyours-shake');
        setTimeout(function() {
          animTarget.classList.remove('beyours-shake');
          animTarget.classList.add('beyours-pulse-target');
          setTimeout(function() { animTarget.classList.remove('beyours-pulse-target'); }, 2400);
        }, 450);
      }
    }

    function hideNudge() {
      nudge.setAttribute('data-show', 'false');
    }

    function updateState(withAnimation) {
      var missing = getMissingSelector();
      if (!missing) hideNudge(); else showNudge(missing, withAnimation);
    }

    // Listen on the form, not on document — these handlers belong to this form
    // and will be GC'd when the form is removed.
    form.addEventListener('change', function(e) {
      if (!e.target.matches) return;
      if (e.target.matches('input[type="radio"], select') && e.target.getAttribute('form') === formId) {
        setTimeout(function() { updateState(false); }, 10);
      }
    });

    submitBtns.forEach(function(submitBtn) {
      submitBtn.addEventListener('click', function(e) {
        var missing = getMissingSelector();
        if (missing) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showNudge(missing, true);
        }
      }, true);
    });

    form.addEventListener('submit', function(e) {
      var missing = getMissingSelector();
      if (missing) {
        e.preventDefault();
        showNudge(missing, true);
      }
    }, true);
  }

  // ==========================================================================
  // POLLING FALLBACK FOR REPAINT
  // (catches any event-name drift if variant:changed doesn't fire)
  // ==========================================================================

  var _lastPollVariantId = null;
  var _pollInterval = null;
  function startRepaintPoll() {
    if (_pollInterval) clearInterval(_pollInterval);
    _lastPollVariantId = null;
    _pollInterval = setInterval(function() {
      var state = getState();
      if (!state) return;
      var id = getCurrentVariantId(state);
      if (id !== _lastPollVariantId) {
        _lastPollVariantId = id;
        repaint();
        updateLengthMeta();
      }
    }, 250);
  }

  // ==========================================================================
  // MAIN INIT — runs on first load, bb:section-reloaded, bfcache, and pageshow
  // Idempotent: every component handles its own already-bound case.
  // ==========================================================================

  function init() {
    // Sticky/title/price repaint state
    repaint();
    updateLengthMeta();
    startRepaintPoll();

    // Reviews badge
    initReviewsBadge();

    // EDD (popover may not exist yet; bindEddInstance is a no-op until it does)
    initEdd();

    // Nudge (rebinds against the current form element)
    initBeyoursNudge();

    // Sticky show/hide initial pass
    updateStickyVisibility();

    // Colour row is a single scroller now — bring the current colour into view.
    revealActiveSwatch();
  }

  // ==========================================================================
  // COLOUR SWATCH SCROLLER
  // ==========================================================================

  // The swatches are one horizontally-scrolling row. The active colour is often well past
  // the fold of that row (Classic Shirt has 28), so without this the customer sees a row
  // of other colours with no sign of which one they are looking at.
  function revealActiveSwatch() {
    var row = document.querySelector('.beyours-bb .bb-color-swatch-block .beyours-image-swatches');
    if (!row) return;
    var active = row.querySelector('.product_btn.is-active, .product_btn:has(img.active-swatch)');
    if (!active) return;
    // scrollIntoView would also scroll the PAGE to the colour row, yanking the customer
    // away from the top of the PDP. Setting scrollLeft moves only the row.
    var target = active.offsetLeft - (row.clientWidth - active.offsetWidth) / 2;
    row.scrollLeft = Math.max(0, target);
  }

  // ==========================================================================
  // DOCUMENT-LEVEL LISTENERS — bound ONCE at script load, never re-bound
  // ==========================================================================

  document.addEventListener('change', onRadioChange);
  document.addEventListener('variant:changed', repaint);
  document.addEventListener('variant:change', repaint);
  document.addEventListener('click', onScrollToReviewsClick);
  document.addEventListener('click', onDeliveryOpen, true);
  window.addEventListener('scroll', updateStickyVisibility, { passive: true });
  window.addEventListener('resize', updateStickyVisibility, { passive: true });

  // Observer fallback — if a new .bb-edd appears (drawer/popover lazy-render),
  // bind to it without waiting for click.
  if (window.MutationObserver) {
    new MutationObserver(function() {
      if (document.querySelector('.bb-edd [data-bb-edd-input]')) initEdd();
    }).observe(document.body, { childList: true, subtree: true });
  }

  // ==========================================================================
  // INIT TRIGGERS
  // ==========================================================================

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The custom event dispatched by <color-metafield> in theme.js after it
  // swaps .main-product-alternate's innerHTML.
  document.addEventListener('bb:section-reloaded', init);

  // bfcache restore
  window.addEventListener('pageshow', function(e) { if (e.persisted) init(); });

  // Also catch sticky visibility updates after short delays for layout-shift hiccups
  setTimeout(updateStickyVisibility, 100);
  setTimeout(updateStickyVisibility, 500);
  setTimeout(updateStickyVisibility, 1500);
})();
